module.exports = __webpack_public_path__ + "static/media/CetraRudy_HEIGHT_2_60fps_vimeo.32d6cdb9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/vids/CetraRudy_HEIGHT_2_60fps_vimeo.mp4
// module id = 150
// module chunks = 0